import type { Middleware } from 'redux';

import { getLog, setLog } from './log';
import logState from './logState';

export const realtimeLogger: Middleware = () => (next) => (action) => {
  setLog(logState(getLog(), action));

  return next(action);
};
